import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Header from "../../../../components/Header";
import Footer from "../../../../components/Footer";
import BhStory from "../../../../components/BhStory";
import "../../../Services/styleAllServices.css";

import aerationProcess from "../../../../assets/img/lawn-aeration.jpg";
import soilSample from "../../../../assets/img/soil-sample.jpg";
import healthyLawn from "../../../../assets/img/lawn-health.jpg";import burhanTeam from "../../../../assets/img/burhan-team.jpg";

export default function DeltaLawnAeration() {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);

    // Canonical URL
    const canonicalUrl = `https://bur-han.ca${location.pathname}`;
    let linkTag = document.querySelector('link[rel="canonical"]');
    if (linkTag) {
      linkTag.setAttribute("href", canonicalUrl);
    } else {
      linkTag = document.createElement("link");
      linkTag.setAttribute("rel", "canonical");
      linkTag.setAttribute("href", canonicalUrl);
      document.head.appendChild(linkTag);
    }

    // TITLE - Optimized for "Lawn Aeration Delta" (Service + Location format)
    const newTitle = "Lawn Aeration Delta | Professional Core Aeration | BUR-HAN";
    document.title = newTitle;

    // META DESCRIPTION - Compelling with keywords and benefits
    const newDescription = "Professional lawn aeration Delta. Relieve soil compaction, improve drainage & grow healthier grass. Core aeration services for residential & commercial properties. Free quote: 604-983-2687";
    let descriptionMetaTag = document.querySelector('meta[name="description"]');
    if (descriptionMetaTag) {
      descriptionMetaTag.setAttribute("content", newDescription);
    } else {
      descriptionMetaTag = document.createElement("meta");
      descriptionMetaTag.setAttribute("name", "description");
      descriptionMetaTag.setAttribute("content", newDescription);
      document.head.appendChild(descriptionMetaTag);
    }

    // KEYWORDS - Comprehensive Delta aeration keywords
    const newKeywords = [
      "lawn aeration Delta",
      "core aeration Delta",
      "lawn aeration near me Delta",
      "aeration service Delta",
      "lawn care Delta",
      "soil compaction relief Delta",
      "lawn health improvement Delta",
      "professional aeration Delta",
      "lawn maintenance Delta",
      "best aeration service Delta",
      "residential lawn aeration Delta",
      "commercial lawn aeration Delta",
      "lawn treatment Delta",
      "spring aeration Delta",
      "fall aeration Delta"
    ].join(", ");
    
    let keywordsMetaTag = document.querySelector('meta[name="keywords"]');
    if (keywordsMetaTag) {
      keywordsMetaTag.setAttribute("content", newKeywords);
    } else {
      keywordsMetaTag = document.createElement("meta");
      keywordsMetaTag.setAttribute("name", "keywords");
      keywordsMetaTag.setAttribute("content", newKeywords);
      document.head.appendChild(keywordsMetaTag);
    }

    // GEO META TAGS - Delta specific
    let geoTag = document.querySelector('meta[name="geo.placename"]');
    if (geoTag) {
      geoTag.setAttribute("content", "Delta, British Columbia");
    } else {
      geoTag = document.createElement("meta");
      geoTag.setAttribute("name", "geo.placename");
      geoTag.setAttribute("content", "Delta, British Columbia");
      document.head.appendChild(geoTag);
    }

    // OPEN GRAPH TAGS
    let ogTitleTag = document.querySelector('meta[property="og:title"]');
    if (ogTitleTag) {
      ogTitleTag.setAttribute("content", newTitle);
    } else {
      ogTitleTag = document.createElement("meta");
      ogTitleTag.setAttribute("property", "og:title");
      ogTitleTag.setAttribute("content", newTitle);
      document.head.appendChild(ogTitleTag);
    }

    let ogDescriptionTag = document.querySelector('meta[property="og:description"]');
    if (ogDescriptionTag) {
      ogDescriptionTag.setAttribute("content", newDescription);
    } else {
      ogDescriptionTag = document.createElement("meta");
      ogDescriptionTag.setAttribute("property", "og:description");
      ogDescriptionTag.setAttribute("content", newDescription);
      document.head.appendChild(ogDescriptionTag);
    }

    let ogUrlTag = document.querySelector('meta[property="og:url"]');
    if (ogUrlTag) {
      ogUrlTag.setAttribute("content", canonicalUrl);
    } else {
      ogUrlTag = document.createElement("meta");
      ogUrlTag.setAttribute("property", "og:url");
      ogUrlTag.setAttribute("content", canonicalUrl);
      document.head.appendChild(ogUrlTag);
    }

    // TWITTER CARDS
    let twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute("content", newTitle);
    } else {
      twitterTitle = document.createElement("meta");
      twitterTitle.setAttribute("name", "twitter:title");
      twitterTitle.setAttribute("content", newTitle);
      document.head.appendChild(twitterTitle);
    }

    let twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute("content", newDescription);
    } else {
      twitterDescription = document.createElement("meta");
      twitterDescription.setAttribute("name", "twitter:description");
      twitterDescription.setAttribute("content", newDescription);
      document.head.appendChild(twitterDescription);
    }

  }, [location.pathname]);

  // Schema markup for Lawn Aeration Delta - FIXED VERSION
// Schema markup for Lawn Aeration Delta - VALIDATED VERSION
  useEffect(() => {
    const schemaScript = document.createElement("script");
    schemaScript.setAttribute("type", "application/ld+json");
    schemaScript.setAttribute("data-schema", "delta-aeration");

    schemaScript.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service", // Using Service type allows the 'serviceType' property
      "name": "Lawn Aeration Delta",
      "serviceType": "Core Aeration", // This is now valid!
      "description": "Professional core lawn aeration services in Delta. Relieve soil compaction, improve drainage, and promote healthier grass growth.",
      "provider": {
        "@type": "LocalBusiness",
        "name": "BUR-HAN Garden & Lawn Care",
        "telephone": "+1-604-983-2687",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "2323 Old Dollarton Rd Unit A",
          "addressLocality": "North Vancouver",
          "addressRegion": "BC",
          "postalCode": "V7H 1A9",
          "addressCountry": "CA"
        }
      },
      "areaServed": {
        "@type": "City",
        "name": "Delta",
        "sameAs": "https://en.wikipedia.org/wiki/Delta"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Lawn Aeration Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Residential Lawn Aeration Delta"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Commercial Lawn Aeration Delta"
            }
          }
        ]
      }
    });

    const existingSchema = document.querySelector('script[data-schema="delta-aeration"]');
    if (existingSchema) {
      existingSchema.remove();
    }
    document.head.appendChild(schemaScript);
  }, [location.pathname]);

  return (
    <div className="wrapper">
      <Header />
      <div className="serviceItemsHeader">
        {/* H1 - Optimized with primary keyword first */}
        <h1 data-aos="zoom-in">Lawn Aeration Delta </h1>
      </div>
      <div className="serviceItemsMain">
        <section id="about" className="about">
          <h2
            data-aos="fade-down"
            style={{
              margin: "2vw",
              textAlign: "center",
              fontSize: "2vw",
              textTransform: "uppercase",
            }}
          >
            "Breathe new life into your lawn with professional core aeration"
          </h2>
          <hr />
          <div className="row writtenContent">
            <div
              className="col-lg-6 order-1 order-lg-2 px-5 "
              data-aos="fade-left"
            >
              <img loading="lazy"
                src={burhanTeam}
                alt="BUR-HAN Landscaping Team "
                className="img-fluid bhTeam"
              />
            </div>
            <div
              className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content"
              data-aos="fade-right"
            >
              <div className="corner-left">
                <div className="title" data-aos="zoom-in">
                  <h3>BUR-HAN GARDEN & LAWN CARE</h3>
                </div>
                <div
                  className="aboutSentence"
                  data-aos="fade-right"
                  data-duration="2000"
                >
                  <p>
                    BUR-HAN Garden & Lawn Care has been providing Residential &
                    Commercial landscaping services for over 30 years.{" "}
                    <a href="/our-projects" className="internal-link">
                      View our completed landscaping projects here.
                    </a>{" "}
                    Delta's flat agricultural plain and heavier clay-loam soils can hold moisture and compact under the weight of the region's significant rainfall. BUR-HAN's professional core aeration service relieves compaction across Delta properties — from Ladner waterfront homes to North Delta family yards — improving drainage and nutrient uptake after the long, wet Lower Mainland winters that make aeration particularly beneficial in this region.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="banner-section">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <h3
                  className="heading"
                  data-aos="fade-right"
                  style={{ textTransform: "uppercase" }}
                >
                  "Your lawn works hard - <span>let it breathe</span>"
                </h3>
              </div>
              <div
                className="col-lg-6 col-md-12 col-sm-12"
                data-aos="fade-left"
              >
                <p className="text">
                  "Core aeration is like giving your lawn a deep tissue massage
                  - it relieves pressure points and stimulates healthy new
                  growth."
                </p>
              </div>
            </div>
          </div>
        </div>

        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy"
              src={aerationProcess}
              alt="Close-up of lawn aeration machine removing soil plugs"
              title="Professional core aeration in progress"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <span className="caption d-block mb-2 font-weight-bold">
              The BUR-HAN Difference
            </span>
            <h3 className="headingImageText text-uppercase">
              Our Aeration Process
            </h3>
            <p className="mb-3">
              We don't just poke holes in your lawn - we perform true core
              aeration using commercial-grade equipment that removes actual
              plugs of soil. This method is far more effective than spike
              aeration for relieving compaction. Our process includes:
            </p>
            <ul>
              
              <li>
                <strong>Commercial-Grade Core Aeration:</strong> We use powerful, professional-grade aerators that extract uniform soil plugs, ensuring deep penetration and maximum relief from compaction across your entire lawn.
              </li>
             
              <li>
                <strong>Beneficial Plug Integration:</strong> The extracted soil plugs are left on the lawn's surface. They naturally break down, returning valuable organic matter and essential nutrients directly back into the soil.
              </li>
              <li>
                <strong>Expert Post-Service Guidance:</strong> We provide clear, actionable recommendations for watering, fertilizing, and overseeding (if desired) to ensure your lawn recovers quickly and fully capitalizes on the aeration benefits.
              </li>
            </ul>
          
          </div>
        </section>

        <section className="section-container">
          <div className="text-container px-5" data-aos="fade-up">
            <h3 className="headingImageText text-uppercase">
              Benefits You'll Notice
            </h3>
            <ul>
              <li>
                <strong>Deeper roots:</strong> Aerated lawns develop deeper root
                systems, making them more drought-resistant
              </li>
              <li>
                <strong>Better nutrient absorption:</strong> Fertilizers work
                more effectively when they can reach the roots
              </li>
              <li>
                <strong>Improved drainage:</strong> Reduces puddling and runoff
                during heavy rains
              </li>
              <li>
                <strong>Thatch reduction:</strong> Helps break down thatch
                layers naturally
              </li>
              <li>
                <strong>Lush growth:</strong> Expect noticeably thicker, greener
                grass within weeks
              </li>
            </ul>
            <p>
              Many customers combine aeration with our overseeding service for
              maximum impact. The aeration holes provide perfect seed-to-soil
              contact for new grass establishment.
            </p>
          </div>
          <div className="image-container px-5" data-aos="fade-left">
            <img loading="lazy"
              src={soilSample}
              alt="Vibrant green lawn two weeks after aeration service"
              title="Healthy lawn growth after professional aeration"
            />
          </div>
        </section>
        <section className="section-container">
          <div className="image-container px-5" data-aos="fade-right">
            <img loading="lazy"
              src={healthyLawn} // You might want to add another image here showing root growth
              alt="Diagram showing grass root development before and after aeration"
              title="The science behind lawn aeration"
            />
          </div>
          <div className="text-container px-5" data-aos="fade-up">
            <span className="caption d-block font-weight-bold">
              The Science of Healthier Turf
            </span>
            <h3 className="headingImageText text-uppercase">
              How Aeration Revitalizes Your Lawn
            </h3>
            <p className="mb-3">
              Professional core aeration initiates a biological cascade that
              transforms your lawn at the cellular level:
            </p>
            <ul>
              <li>
                <strong>Oxygen infusion:</strong> Soil compaction collapses the
                air pockets roots need. Aeration reintroduces oxygen,
                stimulating microbial activity that breaks down thatch and
                organic matter into plant-available nutrients.
              </li>
              <li>
                <strong>Hydraulic conductivity:</strong> Each aeration channel
                improves water infiltration rates by up to 200%, preventing
                runoff while ensuring moisture reaches the root zone where it's
                needed most.
              </li>
              <li>
                <strong>Root architecture:</strong> Studies show aerated lawns
                develop 30-40% deeper root mass within 60 days. This expanded
                root system accesses more nutrients and withstands drought
                stress.
              </li>
              <li>
                <strong>Gas exchange:</strong> The process vents harmful CO
                <sub>2</sub> and methane that accumulate in compacted soils,
                creating an environment where beneficial soil organisms thrive.
              </li>
            </ul>
          </div>
        </section>



        <section className="how-it-works" data-aos="fade-up">
          <div className="container py-4 px-5">
            <h3 className="headingImageText text-uppercase mb-4">How Our Delta Lawn Aeration Service Works</h3>
            <div className="steps-grid">
              <div className="step-item">
                <span className="step-number">1</span>
                <h4>Site Assessment</h4>
                <p>We assess your Delta lawn's soil compaction level, grass type, and current condition before starting. This ensures we use the right equipment settings and recommend the ideal timing for your property.</p>
              </div>
              <div className="step-item">
                <span className="step-number">2</span>
                <h4>Core Aeration</h4>
                <p>Using commercial-grade core aerators, we systematically remove small plugs of soil across your entire lawn. These plugs are left on the surface — they break down naturally and return organic matter back into the soil.</p>
              </div>
              <div className="step-item">
                <span className="step-number">3</span>
                <h4>Post-Service Guidance</h4>
                <p>We leave you with clear recommendations for watering and fertilizing in the days following aeration — maximizing the benefit of the service and helping your Delta lawn recover quickly and grow stronger roots.</p>
              </div>
            </div>
          </div>
        </section>

        <section className="lawnCareLinks" data-aos="fade-up">
          <h2>More Lawn Care Services in Delta</h2>
          <div className="lawnCareLinks-grid">
      <a href="/lawn-mowing-delta">
        <strong>Lawn Mowing Delta</strong>
        <span>Weekly electric mowing service</span>
      </a>
      <a href="/lawn-fertilizing-delta">
        <strong>Lawn Fertilizing Delta</strong>
        <span>Seasonal fertilization programs</span>
      </a>
      <a href="/landscaping-delta">
        <strong>Landscaping Delta</strong>
        <span>Full-service landscape maintenance</span>
      </a>
          </div>
        </section>
        <div className="secondBanner">
          <div className="container" data-aos="fade-down">
            <div className="row">
              <div className="col-md-6">
                <h3>Ready for a healthier lawn?</h3>
                <p>
                  Our Specialists can assess your property and
                  recommend the perfect aeration schedule for your specific
                  grass type and soil conditions.
                </p>
              </div>
              <div className="col-md-6">
                <div className="call-to-action text-right">
                  <a href="/contact-us" className="get-a-quote">
                    Get A Quote{" "}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}
